import React from "react";
import { Fieldset, Legend } from "@/components/fieldset";
import { Badge } from "@/components/badge";
import type { IGroup } from "@/apis/groups/getGroupList";

interface GroupDetailsProps {
  group: IGroup;
}

const GroupDetails: React.FC<GroupDetailsProps> = ({ group }) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Define a detail item component for consistent styling
  const DetailItem = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <div className="py-3 sm:grid sm:grid-cols-3 sm:gap-4">
      <div className="text-sm font-medium text-gray-500">{label}</div>
      <div className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
        {value || "-"}
      </div>
    </div>
  );

  return (
    <div className="space-y-8">
      {/* Basic Information */}
      <Fieldset>
        <Legend>Basic Information</Legend>
        <div className="mt-4 border-t border-b border-gray-100">
          <dl className="divide-y divide-gray-100">
            <DetailItem label="Name" value={group.name} />
            <DetailItem
              label="Status"
              value={
                group.status === "active" ? (
                  <Badge color="lime">Active</Badge>
                ) : (
                  <Badge color="zinc">Inactive</Badge>
                )
              }
            />
            <DetailItem label="Created" value={formatDate(group.created_at)} />
            <DetailItem
              label="Last Updated"
              value={formatDate(group.updated_at)}
            />
          </dl>
        </div>
      </Fieldset>

      {/* Member Information */}
      <Fieldset>
        <Legend>Member Information</Legend>
        <div className="mt-4 border-t border-b border-gray-100">
          <dl className="divide-y divide-gray-100">
            <DetailItem
              label="Total Members"
              value={`${group.users?.length || 0} members`}
            />
          </dl>
        </div>
      </Fieldset>
    </div>
  );
};

export default GroupDetails;
